module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_iter-step.js
// module id = 105
// module chunks = 0